__turbopack_context__.v({
  "addOnLabel": "plancard-module-scss-module__o_aK4a__addOnLabel",
  "badgeStyle": "plancard-module-scss-module__o_aK4a__badgeStyle",
  "bannerHidden": "plancard-module-scss-module__o_aK4a__bannerHidden",
  "blurredBackground": "plancard-module-scss-module__o_aK4a__blurredBackground",
  "blurredBackgroundBadge": "plancard-module-scss-module__o_aK4a__blurredBackgroundBadge",
  "bulletList": "plancard-module-scss-module__o_aK4a__bulletList",
  "button": "plancard-module-scss-module__o_aK4a__button",
  "buttonWrapper": "plancard-module-scss-module__o_aK4a__buttonWrapper",
  "buttonWrapperUnderCTA": "plancard-module-scss-module__o_aK4a__buttonWrapperUnderCTA",
  "cardDescription": "plancard-module-scss-module__o_aK4a__cardDescription",
  "cardEyebrow": "plancard-module-scss-module__o_aK4a__cardEyebrow",
  "cardHeading": "plancard-module-scss-module__o_aK4a__cardHeading",
  "checkmarkList": "plancard-module-scss-module__o_aK4a__checkmarkList",
  "circle": "plancard-module-scss-module__o_aK4a__circle",
  "descriptionFade": "plancard-module-scss-module__o_aK4a__descriptionFade",
  "expandableContent": "plancard-module-scss-module__o_aK4a__expandableContent",
  "headingSection": "plancard-module-scss-module__o_aK4a__headingSection",
  "hiddenContent": "plancard-module-scss-module__o_aK4a__hiddenContent",
  "noList": "plancard-module-scss-module__o_aK4a__noList",
  "optionalItemHeading": "plancard-module-scss-module__o_aK4a__optionalItemHeading",
  "optionalItemSubheading": "plancard-module-scss-module__o_aK4a__optionalItemSubheading",
  "optionalItemWrapper": "plancard-module-scss-module__o_aK4a__optionalItemWrapper",
  "optionalItems": "plancard-module-scss-module__o_aK4a__optionalItems",
  "planCard": "plancard-module-scss-module__o_aK4a__planCard",
  "planCardFlag": "plancard-module-scss-module__o_aK4a__planCardFlag",
  "planPriceWrapper": "plancard-module-scss-module__o_aK4a__planPriceWrapper",
  "planPriceWrapperUnderCTA": "plancard-module-scss-module__o_aK4a__planPriceWrapperUnderCTA",
  "showMoreWrapper": "plancard-module-scss-module__o_aK4a__showMoreWrapper",
  "switchContainer": "plancard-module-scss-module__o_aK4a__switchContainer",
  "switchOn": "plancard-module-scss-module__o_aK4a__switchOn",
  "switchToggle": "plancard-module-scss-module__o_aK4a__switchToggle",
  "tilesFadeOut": "plancard-module-scss-module__o_aK4a__tilesFadeOut",
  "tilesFadeWrapper": "plancard-module-scss-module__o_aK4a__tilesFadeWrapper",
  "toggleContainer": "plancard-module-scss-module__o_aK4a__toggleContainer",
  "truncatedDescription": "plancard-module-scss-module__o_aK4a__truncatedDescription",
  "viewMore": "plancard-module-scss-module__o_aK4a__viewMore",
  "whiteText": "plancard-module-scss-module__o_aK4a__whiteText",
});
